import styled from 'styled-components';
import { fontSize, fontWeight, primaryColor, tertiaryColor } from '@styles/utils';

export const HeaderTitleContainer = styled.div`
  position: relative;
  padding: 104px 16px 48px 16px;
  background-color: ${primaryColor(500)};
  overflow: hidden;

  @media screen and (max-width: 1230px) {
    padding: 80px 16px 40px 16px;
  }
`;

export const HeaderTitleContent = styled.div`
  padding: 20px;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: solid 5px ${tertiaryColor(100)};
  width: 100%;
  max-width: max-content;

  @media screen and (max-width: 1230px) {
    max-width: 100%;
    line-height: 1.2;
  }
`;

export const HeaderTitle = styled.h1`
  ${fontSize.h1};
  font-weight: ${fontWeight.semiBold};
  color: ${tertiaryColor(100)};
  text-align: center;
`;
